
// Maintenance Mode Utility
// This utility helps manage the maintenance mode state

export const MAINTENANCE_MODE_KEY = 'site-maintenance-mode';

/**
 * Check if maintenance mode is enabled
 */
export const isMaintenanceModeEnabled = (): boolean => {
  const mode = localStorage.getItem(MAINTENANCE_MODE_KEY);
  return mode === 'true';
};

/**
 * Enable maintenance mode
 */
export const enableMaintenanceMode = (): void => {
  localStorage.setItem(MAINTENANCE_MODE_KEY, 'true');
  // Reload the page to apply maintenance mode
  window.location.reload();
};

/**
 * Disable maintenance mode
 */
export const disableMaintenanceMode = (): void => {
  localStorage.setItem(MAINTENANCE_MODE_KEY, 'false');
  // Reload the page to exit maintenance mode
  window.location.reload();
};

/**
 * Toggle maintenance mode
 */
export const toggleMaintenanceMode = (): void => {
  const currentMode = isMaintenanceModeEnabled();
  if (currentMode) {
    disableMaintenanceMode();
  } else {
    enableMaintenanceMode();
  }
};
